"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkIsDateBetweenDates = exports.getDiffDaysBetweenDates = exports.checkIsDateGreaterThanToday = exports.formatDateToView = exports.formatDateTimeToView = exports.Today = void 0;
const moment_1 = __importDefault(require("moment"));
const Today = () => {
    return (0, moment_1.default)().format('YYYY-MM-DD');
};
exports.Today = Today;
const formatDateTimeToView = (date) => (0, moment_1.default)(date).format('DD/MM/YYYY hh:mm');
exports.formatDateTimeToView = formatDateTimeToView;
const formatDateToView = (date) => (0, moment_1.default)(date).format('DD/MM/YYYY');
exports.formatDateToView = formatDateToView;
const checkIsDateGreaterThanToday = (date) => (0, moment_1.default)(date).isAfter((0, moment_1.default)());
exports.checkIsDateGreaterThanToday = checkIsDateGreaterThanToday;
const getDiffDaysBetweenDates = (start, end) => {
    const startDate = (0, moment_1.default)(new Date(start), 'YYYY-MM-DD');
    const endDate = (0, moment_1.default)(new Date(end), 'YYYY-MM-DD');
    return `${moment_1.default.duration(endDate.diff(startDate)).asDays()}`;
};
exports.getDiffDaysBetweenDates = getDiffDaysBetweenDates;
const checkIsDateBetweenDates = (start, end, pivot) => (0, moment_1.default)(pivot).isBetween(start, end, null, '[]');
exports.checkIsDateBetweenDates = checkIsDateBetweenDates;
